import styled from 'styled-components';

export const StyledSideMenuGroup = styled.ul`
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	height: 100%;
`;
